import { gql } from "graphql-request";

export const mutation = gql`
mutation UploadFile(
  $itemId: ID!,
  $columnId: String!
  $file: File!
) {
  add_file_to_column (item_id: $itemId, file: $file, column_id: $columnId) {
    id
  }
}
`;

export async function uploadFileMutation(params: {
	itemId: string;
	columnId: string;
	file: FormDataEntryValue;
}) {
	const formData = new FormData();
	formData.append("query", mutation);
	formData.append(
		"map",
		'{"file":"variables.file", "columnId" :"variables.columnId", "itemId": "variables.itemId"}',
	);
	formData.append("file", params.file);
	formData.append("columnId", params.columnId);
	formData.append("itemId", params.itemId);

	return fetch("https://api.monday.com/v2/file", {
		method: "POST",
		headers: {
			Authorization: process.env.MONDAY_API_TOKEN,
		},
		body: formData,
	});
}
